import BackofficeController from "backoffice_controller";

export default class extends BackofficeController {
  static targets = ["boTableOfContents", "htmlList"];

  connect() {
    this._displayBoTableOfContents();
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  scrollToElement(event) {
    event.preventDefault();

    const id = event.target.dataset.idTargeted;
    const target = document.querySelector(id);

    if (!target) {
      console.warn(`[stimulus-scroll-to] The element with the id: "${id}" does not exist on the page.`);
      return;
    }

    this._resetAccordion();
    target.parentNode.querySelector('.accordion-collapse').classList.add('show');
    const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - 70;

    window.scrollTo({
      top: offsetPosition,
      behavior: this.behavior,
    });
  }

  // PRIVATE

  _resetAccordion() {
    [...document.querySelectorAll('.accordion-collapse')].forEach((item) => {
      item.classList.remove('show');
    });
  }

  _displayBoTableOfContents() {
    setTimeout(() => {
      if (!this.hasBoTableOfContentsTarget) return;

      const accordionElements = document.querySelectorAll(".accordion");
      if (accordionElements.length > 0) {
        accordionElements.forEach((element) => {
          const titleElement = element.querySelector(".accordion-header");

          this.htmlListTarget.insertAdjacentHTML(
            "beforeend",
            `<li><div class="li-content-container"><div class="anchor" data-action="click->bo-toc#scrollToElement" data-id-targeted="#${titleElement.id}">${titleElement.innerText}</div></div></li>`
          );
        });
        this.boTableOfContentsTarget.classList.remove("d-none");
      }
    }, 2000);
  }
}
